import gql from 'graphql-tag';

const WRITE_REVIEW = gql`
  mutation writeReview($input: CreateReviewInput!) {
    reviewsMutations {
        createReview(review: $input) {
            success
            message
            is_order_incorrect
            is_email_incorrect
        }
    }
  }
`;

export default WRITE_REVIEW;
